import { atom } from 'jotai';
import { workflowAtom } from './atoms';
import { ServerStepGroup } from './ServerWorkflowType';

export const businessProductAtom = atom(
  (get) => get(workflowAtom).businessProduct,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), businessProduct: newValue });
  }
);

export const cronTimezoneAtom = atom(
  (get) => get(workflowAtom).cronTimezone,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), cronTimezone: newValue });
  }
);

export const cronTriggerAtom = atom(
  (get) => get(workflowAtom).cronTrigger,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), cronTrigger: newValue });
  }
);

export const deprecatedAtom = atom(
  (get) => get(workflowAtom).deprecated,
  (get, set, newValue: boolean) => {
    set(workflowAtom, { ...get(workflowAtom), deprecated: newValue });
  }
);

export const descriptionAtom = atom(
  (get) => get(workflowAtom).description,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), description: newValue });
  }
);

export const disabledAtom = atom(
  (get) => get(workflowAtom).disabled,
  (get, set, newValue: boolean) => {
    set(workflowAtom, { ...get(workflowAtom), disabled: newValue });
  }
);

export const eventParametersMappingAtom = atom(
  (get) => get(workflowAtom).eventParametersMapping,
  (get, set, newValue: string) => {
    set(workflowAtom, {
      ...get(workflowAtom),
      eventParametersMapping: newValue,
    });
  }
);

export const ftpDropzoneAtom = atom(
  (get) => get(workflowAtom).ftpDropzone,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), ftpDropzone: newValue });
  }
);

export const nameAtom = atom(
  (get) => get(workflowAtom).name,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), name: newValue });
  }
);

export const nextStepGroupAtom = atom(
  (get) => get(workflowAtom).nextStepGroup,
  (get, set, newValue: ServerStepGroup | null) => {
    set(workflowAtom, { ...get(workflowAtom), nextStepGroup: newValue });
  }
);

export const notifyEmailsAtom = atom(
  (get) => get(workflowAtom).notifyEmails,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), notifyEmails: newValue });
  }
);

export const productGroupAtom = atom(
  (get) => get(workflowAtom).productGroup,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), productGroup: newValue });
  }
);

export const reportingIndexAtom = atom(
  (get) => get(workflowAtom).reportingIndex,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), reportingIndex: newValue });
  }
);

export const s3AccessKeyAtom = atom(
  (get) => get(workflowAtom).s3AccessKey,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), s3AccessKey: newValue });
  }
);

export const s3DropzoneAtom = atom(
  (get) => get(workflowAtom).s3Dropzone,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), s3Dropzone: newValue });
  }
);

export const s3PrivateKeyAtom = atom(
  (get) => get(workflowAtom).s3PrivateKey,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), s3PrivateKey: newValue });
  }
);

export const s3RoleArnAtom = atom(
  (get) => get(workflowAtom).s3RoleArn,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), s3RoleArn: newValue });
  }
);

export const s3RoleSessionNameAtom = atom(
  (get) => get(workflowAtom).s3RoleSessionName,
  (get, set, newValue: string | null) => {
    set(workflowAtom, { ...get(workflowAtom), s3RoleSessionName: newValue });
  }
);

export const sftpDropzoneAtom = atom(
  (get) => get(workflowAtom).sftpDropzone,
  (get, set, newValue: string | null) => {
    set(workflowAtom, { ...get(workflowAtom), sftpDropzone: newValue });
  }
);

export const sftpPrivateKeyAtom = atom(
  (get) => get(workflowAtom).sftpPrivateKey,
  (get, set, newValue: string | null) => {
    set(workflowAtom, { ...get(workflowAtom), sftpPrivateKey: newValue });
  }
);

export const slaveAtom = atom(
  (get) => get(workflowAtom).slave,
  (get, set, newValue: string) => {
    set(workflowAtom, { ...get(workflowAtom), slave: newValue });
  }
);

export const strictDropzoneOrderingAtom = atom(
  (get) => get(workflowAtom).strictDropzoneOrdering,
  (get, set, newValue: boolean) => {
    set(workflowAtom, {
      ...get(workflowAtom),
      strictDropzoneOrdering: newValue,
    });
  }
);

export const supportResubmitAtom = atom(
  (get) => get(workflowAtom).supportResubmit,
  (get, set, newValue: boolean) => {
    set(workflowAtom, { ...get(workflowAtom), supportResubmit: newValue });
  }
);

export const supportsPrioritizationAtom = atom(
  (get) => get(workflowAtom).supportsPrioritization,
  (get, set, newValue: boolean) => {
    set(workflowAtom, {
      ...get(workflowAtom),
      supportsPrioritization: newValue,
    });
  }
);

export const tenantAtom = atom(
  (get) => get(workflowAtom).tenant,
  (get, set, newValue: string | null) => {
    set(workflowAtom, { ...get(workflowAtom), tenant: newValue });
  }
);

export const throttleRateAtom = atom(
  (get) => get(workflowAtom).throttleRate,
  (get, set, newValue: number) => {
    set(workflowAtom, { ...get(workflowAtom), throttleRate: newValue });
  }
);

export const timeoutAfterAtom = atom(
  (get) => get(workflowAtom).timeoutAfter,
  (get, set, newValue: string | null) => {
    set(workflowAtom, { ...get(workflowAtom), timeoutAfter: newValue });
  }
);

export const topicIdAtom = atom(
  (get) => get(workflowAtom).topicId,
  (get, set, newValue: string | null) => {
    set(workflowAtom, { ...get(workflowAtom), topicId: newValue });
  }
);

export const unpackInputAtom = atom(
  (get) => get(workflowAtom).unpackInput,
  (get, set, newValue: boolean) => {
    set(workflowAtom, { ...get(workflowAtom), unpackInput: newValue });
  }
);

export const workflowIdAtom = atom(
  (get) => get(workflowAtom).workflowId,
  (get, set, newValue: number) => {
    set(workflowAtom, { ...get(workflowAtom), workflowId: newValue });
  }
);

export const failbackStepGroupAtom = atom(
  (get) => get(workflowAtom).failbackStepGroup,
  (get, set, newValue: ServerStepGroup | null) => {
    set(workflowAtom, { ...get(workflowAtom), failbackStepGroup: newValue });
  }
);
